<template>
<button
  @click="migrate"
  class="btn btn-fill btn-block btn-warning"
>
  Migrar todas as configurações para o novo banco de configurações
</button>
</template>

<script>
import CouchdbClass from 'src/services/CouchdbClass'
import swal from 'sweetalert2'

export default {
  name: 'MigrateConfigurationsToNewDatabase',

  computed: {
    collections: function () {
      return [
        'users',
        'roles',
        'projects',
        'manufacturers',
        'categories',
        'tags',
        'apis'
      ]
    },
    CouchdbAdmin: function () {
      return this.collections.reduce((accumulated, currentValue) => {
        accumulated[currentValue] = new CouchdbClass({ connection: 'default', collection: currentValue })
        return accumulated
      }, {})
    },
    CouchdbConfig: function () {
      return this.collections.reduce((accumulated, currentValue) => {
        accumulated[currentValue] = new CouchdbClass({ connection: 'config', collection: currentValue })
        return accumulated
      }, {})
    }
  },

  methods: {
    migrate () {
      Promise.all(
        this.fetchData()
      ).then(results => {
        this.insertNewDatabase(results)
          .then(() => {
            swal({
              title: 'Migração finalizada',
              type: 'success',
              showConfirmButton: true
            })
          })
          .catch(() => {
            swal({
              title: 'Ocorreu uma falha ou os dados já foram migrados.',
              type: 'warning',
              showConfirmButton: true
            })
          })
      }).catch(err => console.log(err))
    },
    fetchData () {
      const promises = []
      for (let collection of this.collections) {
        promises.push(
          this.CouchdbAdmin[collection].limit(9999999).all()
        )
      }
      return promises
    },
    insertNewDatabase (results) {
      const promises = []
      for (let iterator in results) {
        promises.push(...this.inserDocsAttachments(results[iterator], this.collections[iterator]))
        promises.push(this.insertNew(results[iterator], this.collections[iterator]))
      }
      return Promise.all(promises)
    },
    insertNew (result, collection) {
      return this.CouchdbConfig[collection]
        ._insertBulk(result.map(item => {
          const doc = Object.assign({}, item)
          delete doc._rev
          delete doc._attachments
          return doc
        }))
    },
    inserDocsAttachments (result, collection) {
      return result.map(doc => {
        if (!doc.hasOwnProperty('_attachments')) {
          return []
        }
        return [this.promiseInsertFile(doc, collection)]
      })
    },

    promiseInsertFile (doc, collection) {
      const couchdb = this.CouchdbConfig[collection]
      const couchdbAdmin = this.CouchdbAdmin[collection]
      return new Promise(async function (resolve, reject) {
        const document = Object.assign(doc, {})
        for (let name in document._attachments) {
          const file = await couchdbAdmin._getAttachment(document._id, name)
          console.log(file)
          try {
            await couchdb.insertAttachment(document._id, {
              mymeType: file.type,
              attachmentName: name,
              attachment: file
            })
          } catch (e) {
            console.log(e)
            reject(e)
          }
        }
        resolve(true)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/commands/MigrateConfigurationsToNewDatabase.vue